/**
 * 投诉相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: `/repair/query`,
                data
            })
        },
        list (data){
            return http.json({
                url: `/repair/list`,
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/complaint/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/repair/get?id=${data.id}`
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/complaintNew.js